import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './config';
import { Scholarship } from '../types/types';

export const scholarshipApi = createApi({
  reducerPath: 'scholarshipApi',
  baseQuery,
  tagTypes: ['Scholarships'],
  endpoints: builder => ({
    getScholarships: builder.query<Scholarship[], void>({
      query: () => '/billing/scholarships',
      providesTags: (result) => {
        const items = Array.isArray(result) ? result : (result as any)?.data || [];
        return [
          ...items.map(({ id }: { id: number }) => ({ type: 'Scholarships' as const, id })),
          { type: 'Scholarships', id: 'LIST' },
        ];
      },
    }),
    getStudentScholarships: builder.query<Scholarship[], string | number>({
      query: (studentId) => `/enrollment/students/${studentId}/scholarships`,
      providesTags: (result) => {
        const items = Array.isArray(result) ? result : (result as any)?.data || [];
        return [
          ...items.map(({ id }: { id: number }) => ({ type: 'Scholarships' as const, id })),
          { type: 'Scholarships', id: 'LIST' },
        ];
      },
    }),
    createScholarship: builder.mutation<Scholarship, Partial<Scholarship> & { studentId: number }>({
      query: newScholarship => ({
        url: '/billing/scholarships',
        method: 'POST',
        body: newScholarship,
      }),
      invalidatesTags: ['Scholarships'],
    }),
    updateScholarship: builder.mutation<Scholarship, { id: number; updates: Partial<Scholarship> }>({
      query: ({ id, updates }) => ({
        url: `/billing/scholarships/${id}`,
        method: 'PATCH',
        body: updates,
      }),
      invalidatesTags: ['Scholarships'],
    }),
    deleteScholarship: builder.mutation<void, number>({
      query: id => ({
        url: `/billing/scholarships/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Scholarships'],
    }),
  }),
});

export const {
  useGetScholarshipsQuery,
  useGetStudentScholarshipsQuery,
  useCreateScholarshipMutation,
  useUpdateScholarshipMutation,
  useDeleteScholarshipMutation,
} = scholarshipApi;
